// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"Carousel__2ALmm"};